import { render } from "./InCaseEmergency.vue?vue&type=template&id=08e4d461"
import script from "./InCaseEmergency.vue?vue&type=script&lang=js"
export * from "./InCaseEmergency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__